import { useQuery } from '@apollo/client'
import { GET_USER_ORDERS } from '@services/api/graphql/queries/getUserOrders'

export type OrderKind = 'common' | 'free' | 'subscription' | 'credit'

// HET-3540: item do pedido na listagem — valor/status próprios quando a venda tem
// decomposição por item (order bump); null em vendas antigas.
export interface IUserOrderItem {
  cartItemId: string | null
  name: string | null
  orderBump: boolean
  amountCents: number | null
  itemStatus: 'active' | 'refund_processing' | 'refunded' | null
}

export interface IUserOrder {
  id: string
  productTitle: string | null
  kind: OrderKind
  amountToPay: number | null
  createdAt: string | null
  isSubscription: boolean
  subscriptionStatus: string | null
  paymentStatus: string | null
  items: IUserOrderItem[] | null
}

export const useUserOrders = () => {
  const { data, loading, error, refetch } = useQuery<{
    userOrders: IUserOrder[]
  }>(GET_USER_ORDERS, { fetchPolicy: 'cache-and-network' })

  return { orders: data?.userOrders ?? [], loading, error, refetch }
}
